import React from 'react';

const Login = () => {
    return (
        <div className="container mx-auto p-4">
            <h1>Login Page</h1>
        </div>
    );
};

export default Login;